import { Component, ContentChild, Input, OnInit, TemplateRef } from '@angular/core';
import { GeneralService } from '@ex/module/core/services/general.service';
import { ModuleName } from '../../enums/ModuleName';

@Component({
  selector: 'export-chart-vertical',
  templateUrl: './export-chart-vertical.component.html',
  styleUrls: ['./export-chart-vertical.component.scss']
})
export class ExportChartVerticalComponent implements OnInit {
  data: any;
  ModuleNames = ModuleName;
  @Input() categoryTemplate: TemplateRef<any>;
  @Input() categoriesTemplate: TemplateRef<any>;
  @Input() breakIndex: number = 30;
  @Input() chart: any;
  @Input('data') set d(data: any) {
    data.pie.sort((a, b) => parseFloat(b.value) - parseFloat(a.value));
    this.data = data;
    if (!data?.pie?.length)
      data.pie = data.radar?.data;
  };
  @Input() language;
  @Input() rows: number = 1;
  constructor(public generalService: GeneralService) { }
  ngOnInit(): void {
  }

  breakCondition(index) {
    let indexCalc = this.breakIndex * (this.rows / 2);
    return (index % indexCalc == 0 && index >= indexCalc) ? true : false;
  }
  fullWidthChartCheck(categories) {
    if (categories.find(x => x.length > 15))
      return true;
    else return false;
  }
  logData(x) {
    console.log(x);

  }
}
